/**
 * 문의하기 GraphQL 쿼리/뮤테이션 문자열
 *
 * DRY 원칙: web, mobile 패키지에서 동일한 쿼리 공유
 * 각 패키지에서 gql 태그로 감싸서 사용:
 *   import { gql } from "@apollo/client";
 *   import { CREATE_CONTACT_ISSUE_STRING } from "@ict/shared/graphql/queries/contact";
 *   const CREATE_CONTACT_ISSUE = gql`${CREATE_CONTACT_ISSUE_STRING}`;
 */

export const CREATE_CONTACT_ISSUE_STRING = `
  mutation CreateContactIssue($input: CreateContactIssueInput!) {
    createContactIssue(input: $input) {
      identifier
      title
      status
      createdAt
    }
  }
`;

export const MY_CONTACT_ISSUES_STRING = `
  query MyContactIssues {
    myContactIssues {
      identifier
      title
      description
      status
      createdAt
    }
  }
`;

export const CANCEL_CONTACT_ISSUE_STRING = `
  mutation CancelContactIssue($identifier: String!) {
    cancelContactIssue(identifier: $identifier) {
      identifier
      status
    }
  }
`;

// ============================================
// Types
// ============================================

/** 문의 이슈 항목 (myContactIssues 응답) */
export interface ContactIssueItem {
  identifier: string;
  title: string;
  description: string;
  status: string;
  createdAt: string;
}

// ============================================
// Constants
// ============================================

/** 문의 상태별 뱃지 색상 (Tailwind 클래스) */
export const CONTACT_STATUS_COLORS: Record<string, string> = {
  접수: "bg-yellow-100 text-yellow-800",
  처리중: "bg-blue-100 text-blue-800",
  완료: "bg-green-100 text-green-800",
  취소: "bg-slate-100 text-slate-500",
};
